import {v4} from "uuid";
import {Button, Checkbox, Spin, Tooltip} from "antd";
import {CloseOutlined, LineChartOutlined} from "@ant-design/icons";
import React, {useState} from "react";

export const OPS_STATUS = {
    NOT_CHECK: 0,
    CHECKING: 1,
    COMPLETED: 2,
    ERROR: 3,
}

const OperationGroup = ({}) => {

}

const OperationItem = ({}) => {

}

const errorColor = '#ee5253'
const successColor = '#27ae60'
const normalColor = '#0f0f0f'
const selectedColor = '#01a3a4'
const showKey = true

export default function OperationMenu({operations = [], onCheckedChanged, onClick, disableCheck, selected}) {
    const [expand, setExpand] = useState([])

    const onCheckAll = (title, val) => {
        const items = [...operations.find(x => x.title === title).children]
        onCheckedChanged && onCheckedChanged([...items], val)
    }

    const getColor = (disabled, error, completed) => {
        if(disabled)
            return '#888888'

        if(error && completed)
            return errorColor

        if(!error && completed)
            return successColor

        return normalColor
    }

    const renderHeader = (op, idx) => {
        const checked = op?.children?.filter(item => item.enable).length === op?.children?.length;
        const hasError = op?.children?.find(item => item.hasError && item.status === OPS_STATUS.COMPLETED)
        const hasCompleted = op?.children?.find(item => item.status === OPS_STATUS.COMPLETED)
        const intermediate = op?.children?.filter(item => item.enable).length > 0;

        let time = 0;
        op?.children?.forEach(x => x.time && (time += x.time))

        return (
            <div
                onClick={() => {
                    const key = op?.title
                    if(expand.find(x => x === key))
                        setExpand(expand.filter(x => x !== key))
                    else
                        setExpand([...expand, key])
                }}
                style={{display: 'flex', alignItems: 'center', gap: 8, padding: 4, backgroundColor: 'rgb(230, 238, 242)'}}
            >
                <div onClick={(e) => {e.stopPropagation()}}>
                    {
                        !disableCheck && (
                            <Checkbox
                                disabled={op?.disabled}
                                checked={checked}
                                indeterminate={!checked && intermediate}
                                onChange={(e) => {
                                    onCheckAll(op?.title, e.target.checked)
                                }}
                            />
                        )
                    }
                </div>
                <span style={{color: getColor(op?.disabled, hasError, hasCompleted)}}>
                    {`${op?.title}`} ({time?.toFixed(1)} s)
                </span>
            </div>
        )
    }

    return (
        <div style={{display: 'flex', alignItems: 'start', flexWrap: 'wrap', gap: 16}}>
            {
                operations.map((op, idx) => {
                    return (
                        <div
                            style={{border: '1px solid #cfcfcf', borderRadius: 2, width: 350, paddingBottom: 8, height: 210}}
                            key={op?.title}
                        >
                            {renderHeader(op, idx)}
                            <div style={{marginLeft: 12, marginRight: 12}}>
                                {
                                    op?.children?.map((item, idy) => {
                                        return (
                                            <div style={{display: 'flex', gap: 4, alignItems: 'center'}}>
                                                <div style={{flex: 1}}>
                                                    {
                                                        !disableCheck && (
                                                            <Checkbox
                                                                style={{marginRight: 4}}
                                                                disabled={item.disabled}
                                                                checked={item.enable}
                                                                onChange={(e) => {
                                                                    if (item.disabled)
                                                                        return

                                                                    onCheckedChanged([item], e.target.checked)
                                                                }}
                                                            />
                                                        )
                                                    }
                                                    <a
                                                        onClick={() => {
                                                            if (item.disabled)
                                                                return

                                                            onClick(item)
                                                        }}
                                                        style={{
                                                            flex: 1,
                                                            color: getColor(item.disabled, item.hasError, item.status === OPS_STATUS.COMPLETED),
                                                            fontWeight: item.title === selected?.title ? 'bold': ''
                                                        }}
                                                    >
                                                        {item.title} {item.title === selected?.title ? <>&#x2022;</> : ''}
                                                    </a>
                                                </div>
                                                {item.status === OPS_STATUS.CHECKING && (<Spin size={'small'}/>)}
                                                {item.status === OPS_STATUS.ERROR && (<CloseOutlined />)}
                                                <div>
                                                    {showKey && (`(${item.key_text || item.key})`)}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}